<template lang="pug">
  .site-nav-desktop-v2-sub-nav
    region-list.regions-wrap(v-if="showRegions" v-slot="s")
      .regions-title-wrap.text-left
        p.regions-title.bold.upper.xs-f-medium.lg-f-small.xl-f-medium.max-at-tweak.brand-color-1 Choose a Region
      
      .regions-by-letter
        .letter-wrap.text-left(v-for="letter in s.regionsByLetter")
          span.regions-letter.brand-color-8.bold.upper.xs-f-small.max-at-tweak {{ letter.name }}
          .region-wrap.xs-f-xsmall.max-at-tweak(v-for="region in letter.regions")
            a.text-color-3.semi-bold.xs-f-xsmall.md-f-small.max-at-tweak(:href="'/colorbar/regions/' + region.url_key" @click="mix_trackFTVNavClick('Choose a Region', region.name)") {{region.name}}

    .sub-nav(v-for="nav in subNavs" :key="nav.title")
      .nav-title.bold.upper.xs-f-medium.lg-f-small.xl-f-medium.max-at-tweak.brand-color-1 {{ nav.title }}
      ul(role="menu")
        li.sub-menu-item.text-color-1.xs-f-medium.lg-f-small.xl-f-medium.max-at-tweak(v-for="(item, index) in nav.ctas" :key="index" role="none")
          a.text-color-1.xs-f-medium.lg-f-small.xl-f-medium.max-at-tweak(:href="item.link.href" @click="mix_trackFTVNavClick(nav.title, item.link.text)" role="menuitem") {{item.link.text}}

</template>

<script>
  import SiteNavTrackMixin from "@components/SiteNav/SiteNavTrackMixin/SiteNavTrackMixin";
  import RegionList from "@components/Regions/RegionList/RegionList";

  export default {
    name: "SiteNavDesktopV2SubNav",
    mixins: [SiteNavTrackMixin],

    components: {
      RegionList
    },

    props: {
      title: {
        type: String
      },
      subNavs: {
        type: Array
      }
    },

    computed: {
      showRegions() {
        return this.title === "Book Services" && this.experiments["Nav Tabs June 2025"] && this.experiments["Nav Tabs June 2025"] === "B";
      }
    }
  };
</script>

<style scoped lang="stylus">
  .site-nav-desktop-v2-sub-nav
    display flex
    flex-direction row
    flex-wrap wrap
    justify-content left
    padding-bottom 1em
    
    .sub-nav
      text-align left
      padding 1em
      min-width 17em
      
      .sub-menu-item
        padding 0.5em 0
        
    .regions-wrap
      padding 1em 0
      padding-right 1.5em
      
      .regions-by-letter
        column-count 2
        
        .letter-wrap
          position relative
          border-bottom 1px solid ui-color-5
          padding 0.75em 0
          padding-left 3em
          break-inside avoid-column
          
          &:last-child
            border-bottom none
          
          .regions-letter
            position absolute
            top 0.95em
            left 0.75em
            
        .region-wrap
          padding 0.25em 0
        
    @media mq-max
      .regions-wrap
        padding-right 4em
        
        .regions-by-letter
          column-count 3

</style>
